import { withLazy } from 'app/hocs/withLazy'

export const Staff = withLazy(() => import('features/Staff/pages/Staff'))
